import axios from 'axios'

export default {
  namespaced: true,
  state: {
    stats: null,
    last_content: null,
    loading: false
  },
  mutations: {
    loading(state, value) {
      state.loading = value
    },
    set_data(state, payload) {
      state.last_content = payload.last_content
      state.stats = payload.stats
    }
  },
  actions: {
    fetchData({commit, state}) {
      return new Promise((resolve, reject) => {
        commit('loading', true)
        axios.get('/dashboard')
          .then((response) => {
            commit('set_data', response.data)
            commit('subject/subjects', response.data.subjects, {root: true})
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            commit('loading', false)
          })
      })
    }
  },
  getters: {
    last_content: state => state.last_content,
    stats: state => state.stats,
    loading: state => state.loading
  }
}
